import { render, staticRenderFns } from "./BookmarkPopup.vue?vue&type=template&id=43f2b524&scoped=true&"
import script from "./BookmarkPopup.vue?vue&type=script&lang=js&"
export * from "./BookmarkPopup.vue?vue&type=script&lang=js&"
import style0 from "./BookmarkPopup.vue?vue&type=style&index=0&id=43f2b524&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f2b524",
  null
  
)

export default component.exports